/**
 * @author Hem Chudgar
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
/**
 * LoaderService
 */
@Injectable()
export class LoaderService {
  readonly  isLoading = new BehaviorSubject<boolean>(false);
  show(): void {
     this.isLoading.next(true);
  }

  hide(): void {
     this.isLoading.next(false);
  }
}
